import * as Sentry from '@sentry/vue'
import { App } from 'vue'

export function initSentry (app: App): void {
  const dsn = process.env.VUE_APP_SENTRY_DSN

  if (!dsn) {
    return
  }

  Sentry.init({
    app,
    dsn,
    environment: process.env.NODE_ENV
  })
}
